<footer class="footer">
  <div class="container footer__container">
    <p class="footer__text">
      © <a href="/">Partners</a> 2021 | 
      Сервис для партнеров компании <a href="https://fabrika-klimat.ru/" target="_blank">Фабрика Окон Климат</a></p>
    <p class="footer__copy">Разработка приложения: <a href="https://vk.com/vakil.gayfullin" target="_blank">Вакиль Гайфуллин</a></p>
  </div>
</footer>